export default {
  "content": "<path d=\"M307.72 302.27a8 8 0 01-3.72-6.75V80a48 48 0 00-48-48 48 48 0 00-48 48v215.52a8 8 0 01-3.71 6.74 97.51 97.51 0 00-44.19 86.07A96 96 0 00352 384a97.49 97.49 0 00-44.28-81.73zM256 112v272\" class=\"ionicon-fill-none ionicon-stroke-width\"/><circle cx=\"256\" cy=\"384\" r=\"48\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};